import { api } from "./base";
/**
 * События счётчика сайта через бэкенд (Measurement Protocol), без загрузки tag.js.
 * Шлём оба идентификатора: ycid (Yandex ClientID) и yclid (Yandex ClickID).
 * Если значения нет — соответствующее поле не отправляем.
 */
export const postSiteAnalytics = async (body) => {
    try {
        await api.post("/api/v1/public/analytics/site", {
            kind: body.kind,
            path: body.path ?? "/",
            title: body.title ?? "",
            ...(body.ycid ? { ycid: body.ycid } : {}),
            ...(body.yclid ? { yclid: body.yclid } : {}),
        });
    }
    catch {
        /* не блокируем UI */
    }
};
